<div [ngClass]="{'link': rowEnabled}" (click)="navigateToMemberDetail($event)">
  {{ masterMemberId }}
</div>
